import AddIcon from '@mui/icons-material/Add';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import {
    Autocomplete,
    Box,
    Button,
    Card,
    Checkbox,
    Chip,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    Menu,
    MenuItem,
    Select as MuiSelect,
    Stack,
    Switch,
    TextField,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
// import Link from "@mui/material/Link";
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import dayjs from 'dayjs';
import { useRef } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { REQUIRED_RED } from '../../../App';
import { preventPhoneInputKeys } from '../../../components/FormatNumber/FormatNumber';
import { MuiSelectWithFocus, MuiTextFieldWithFocus, StyledToggleButton, StyledToggleButtonGroup } from '../../../config/MaterialUIConstants';
import { discountProgramApi } from '../../../redux/Account/Pricing/action';
import {
    customerCheckPhoneNumberExist,
    customerCreate,
    deleteCustomerVehicle,
    shopImportedCustomerCreate,
    updatePhoneNumberExistCustomer,
} from '../../../redux/Customer/action';
import { useGetCityMasterList, useGetCountryMasterList, useGetProvinceMasterList } from '../../../services/core/master/master.hooks';
import { useGetShopConfig } from '../../../services/core/settings/settings.hooks';
import { CONTACT_PREFRENCES, masterQueryOptions, PHONE_TYPES } from '../../../utility/Constant';
import { filterUndefined } from '../../../utility/helpers/commonFunction';
import { createVehicleApi, deleteImportedVehicleApi } from '../../../services/core/vehicles/vehicle.api';

import VehicleModalV4 from '../../../common/VehicleModalV4';
import ApexAutoSvg from '../../../utility/Svg/ApexAutoSvg';
import CarSvg from '../../../utility/Svg/CarSvg';
import CustomerFleet from '../../../utility/Svg/CustomerFleet';
import { inputFormatPhoneNumber, removeDashFromPhoneNumber } from '../../Common/FormatPhoneNumber';
import SuccessMessageModal from '../../Common/SuccessMessage';
import { PhoneTypeIcon } from '../Profile/CustomerProfileLeftDataSection';
import CommonDialog from '../../../common/CommonDialog';

// SVG Icons for Vehicle Details
const TrimIcon = ({ width = 20, height = 20 }) => (
    <div style={{ width: width, height: height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
            <path
                d="M19.0055 9.75828C18.4518 4.96928 15.2187 1.72443 10.2809 1.00537C9.96478 0.959378 9.68575 1.21515 9.68575 1.53457V5.08983C11.0351 5.21094 12.2821 5.79647 13.2542 6.76857C14.2263 7.74066 14.8118 8.9947 14.9329 10.3441H18.4741C18.7871 10.3441 19.0414 10.0692 19.0055 9.75828ZM11.4638 10.4263C11.2398 9.50416 10.4835 8.74787 9.56137 8.52384C7.60065 8.04752 5.86906 9.77904 6.34538 11.7398C6.56941 12.6619 7.3257 13.4183 8.24779 13.6422C10.2086 14.1185 11.9401 12.387 11.4638 10.4263ZM8.90462 12.6664C8.0315 12.6664 7.32123 11.9561 7.32123 11.083C7.32123 10.2099 8.0315 9.49962 8.90462 9.49962C9.77773 9.49962 10.488 10.2099 10.488 11.083C10.488 11.9561 9.77773 12.6664 8.90462 12.6664Z"
                fill="#006CDD"
            />
            <path
                d="M8.90279 10.5557C8.61159 10.5557 8.375 10.7923 8.375 11.0835C8.375 11.3747 8.61159 11.6113 8.90279 11.6113C9.194 11.6113 9.43059 11.3747 9.43059 11.0835C9.43059 10.7923 9.194 10.5557 8.90279 10.5557Z"
                fill="#006CDD"
            />
            <path
                d="M14.1756 11.6104C13.8794 11.6104 13.6602 11.3624 13.6592 11.0663C13.655 9.80593 13.1605 8.62012 12.266 7.72561C11.3715 6.8311 10.1857 6.33667 8.92537 6.33241C8.6292 6.33146 8.38128 6.11225 8.38128 5.81608V3.19238C4.17356 3.4718 0.85222 7.0437 0.99673 11.3532C1.13378 15.4404 4.55122 18.8579 8.63849 18.9949C12.948 19.1395 16.5198 15.8181 16.7993 11.6104H14.1756ZM4.80378 6.97727C5.0099 6.77115 5.34407 6.77115 5.55019 6.97727C5.75635 7.18339 5.75635 7.51755 5.55019 7.72368C5.34407 7.9298 5.0099 7.9298 4.80378 7.72368C4.59766 7.51755 4.5977 7.18339 4.80378 6.97727ZM3.63113 11.6104C3.33965 11.6104 3.10333 11.374 3.10333 11.0826C3.10333 10.791 3.33965 10.5548 3.63113 10.5548C3.92261 10.5548 4.15892 10.791 4.15892 11.0826C4.15892 11.374 3.92261 11.6104 3.63113 11.6104ZM5.55019 15.1879C5.34407 15.394 5.0099 15.394 4.80378 15.1879C4.59766 14.9817 4.59766 14.6475 4.80378 14.4414C5.0099 14.2353 5.34407 14.2353 5.55019 14.4414C5.75635 14.6475 5.75635 14.9817 5.55019 15.1879ZM8.90907 16.8883C8.61759 16.8883 8.38128 16.652 8.38128 16.3605C8.38128 16.069 8.61759 15.8327 8.90907 15.8327C9.20056 15.8327 9.43687 16.069 9.43687 16.3605C9.43687 16.652 9.20056 16.8883 8.90907 16.8883ZM9.6331 14.7078C7.03491 15.2044 4.78728 12.9567 5.28376 10.3585C5.55969 8.91452 6.74107 7.73321 8.18501 7.45728C10.7832 6.9608 13.0308 9.20843 12.5344 11.8066C12.2584 13.2506 11.0771 14.4318 9.6331 14.7078ZM13.0144 15.1879C12.8082 15.394 12.4741 15.394 12.268 15.1879C12.0618 14.9817 12.0618 14.6475 12.268 14.4414C12.4741 14.2353 12.8082 14.2353 13.0144 14.4414C13.2205 14.6475 13.2205 14.9817 13.0144 15.1879Z"
                fill="#006CDD"
            />
        </svg>
    </div>
);

const LicensePlateIcon = ({ width = 20, height = 20 }) => (
    <div style={{ width: width, height: height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
            <path
                d="M15.0933 10.396C15.2196 10.396 15.3253 10.3549 15.4107 10.2726C15.496 10.1903 15.5387 10.0883 15.5387 9.96657C15.5387 9.84486 15.496 9.74314 15.4107 9.66143C15.3253 9.57971 15.2199 9.53886 15.0942 9.53886H12.3591C12.2329 9.53886 12.1274 9.58 12.0427 9.66228C11.9579 9.74457 11.9153 9.84628 11.9147 9.96743C11.9141 10.0886 11.9567 10.1903 12.0427 10.2726C12.1286 10.3549 12.2341 10.396 12.3591 10.396H15.0933ZM15.0933 8.02171C15.2196 8.02171 15.3253 7.98057 15.4107 7.89829C15.496 7.81657 15.5387 7.71486 15.5387 7.59314C15.5387 7.47143 15.496 7.36971 15.4107 7.288C15.3253 7.20629 15.2199 7.16514 15.0942 7.16457H12.3591C12.2329 7.16457 12.1274 7.20571 12.0427 7.288C11.9579 7.37029 11.9153 7.47228 11.9147 7.594C11.9141 7.71571 11.9567 7.81743 12.0427 7.89914C12.1286 7.98086 12.2341 8.02171 12.3591 8.02171H15.0933ZM7.40178 11.1211C6.91407 11.1211 6.50104 11.1537 6.16267 11.2189C5.8237 11.284 5.52 11.3891 5.25156 11.5343C5.02044 11.6543 4.84593 11.7851 4.728 11.9269C4.61007 12.0686 4.55141 12.2209 4.552 12.3837C4.552 12.5123 4.60593 12.6197 4.71378 12.706C4.82104 12.7917 4.95259 12.8346 5.10845 12.8346H9.704C9.85926 12.8346 9.98933 12.7877 10.0942 12.694C10.1991 12.6003 10.2516 12.488 10.2516 12.3571C10.2516 12.2131 10.1956 12.0737 10.0836 11.9389C9.97156 11.804 9.79437 11.6691 9.552 11.5343C9.28296 11.3891 8.97926 11.284 8.64089 11.2189C8.30252 11.1537 7.88948 11.1211 7.40178 11.1211ZM7.40178 9.736C7.77689 9.736 8.09274 9.61228 8.34933 9.36486C8.60652 9.11686 8.73511 8.812 8.73511 8.45028C8.73511 8.08857 8.60652 7.784 8.34933 7.53657C8.09215 7.28914 7.7763 7.16514 7.40178 7.16457C7.02726 7.164 6.71141 7.288 6.45422 7.53657C6.19704 7.78514 6.06845 8.08971 6.06845 8.45028C6.06845 8.81086 6.19704 9.11571 6.45422 9.36486C6.71141 9.614 7.02726 9.73771 7.40178 9.736ZM3.43644 16C3.02696 16 2.68533 15.868 2.41156 15.604C2.13778 15.34 2.00059 15.0103 2 14.6149V5.38514C2 4.99029 2.13719 4.66086 2.41156 4.39686C2.68593 4.13286 3.02726 4.00057 3.43556 4H16.5644C16.9733 4 17.3147 4.13229 17.5884 4.39686C17.8622 4.66143 17.9994 4.99086 18 5.38514V14.6157C18 15.01 17.8628 15.3394 17.5884 15.604C17.3141 15.8686 16.9727 16.0006 16.5644 16H3.43644Z"
                fill="#006CDD"
            />
        </svg>
    </div>
);

const VINIcon = ({ width = 20, height = 20 }) => (
    <div style={{ width: width, height: height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
            <path
                d="M2 15V5H3.45455V15H2ZM4.18182 15V5H5.63636V15H4.18182ZM6.36364 15V5H7.09091V15H6.36364ZM8.54545 15V5H10V15H8.54545ZM10.7273 15V5H12.9091V15H10.7273ZM13.6364 15V5H14.3636V15H13.6364ZM15.8182 15V5H18V15H15.8182Z"
                fill="#006CDD"
            />
        </svg>
    </div>
);
// Maps a vehicle as returned by the API into the shape this page keeps in local state.
const mapApiVehicleToLocal = (veh) => ({
    vehcileId: veh?._id,
    fleetUnitNumber: veh?.fleetUnitNumber,
    licenseNumber: veh?.licenseNumber,
    vin: veh?.vin,
    provinceId: veh?.province?._id || veh?.provinceId || undefined,
    provinceObject: {
        provinceCode: veh?.province?.provinceCode,
        _id: veh?.province?._id,
    },
    vehicleMakeId: { _id: veh?.vehicleMake?._id, name: veh?.vehicleMake?.name },
    vehicleModelId: {
        _id: veh?.vehicleModel?._id,
        name: veh?.vehicleModel?.name,
        requestStatus: veh?.vehicleModel?.requestStatus,
    },
    vehicleModelTrimId: { id: veh?.vehicleModelTrim?._id, name: veh?.vehicleModelTrim?.name },
    year: veh?.year || veh?.vehicleYear || '',
});

// A local vehicle can hold either full objects (set by VehicleModalV4's local modes)
// or plain ids (set from an API response), so every id is read both ways.
const buildVehicleApiPayload = (vehicle, isFleet) => {
    const makeId = vehicle?.vehicleMakeId?._id || (typeof vehicle?.vehicleMakeId === 'string' ? vehicle?.vehicleMakeId : undefined);
    const modelId = vehicle?.vehicleModelId?._id || (typeof vehicle?.vehicleModelId === 'string' ? vehicle?.vehicleModelId : undefined);
    const trimId =
        vehicle?.vehicleModelTrimId?._id ||
        vehicle?.vehicleModelTrimId?.id ||
        (typeof vehicle?.vehicleModelTrimId === 'string' ? vehicle?.vehicleModelTrimId : undefined);

    const data = {
        year: vehicle?.year + '',
        vehicleMakeId: makeId,
        vehicleModelId: modelId,
        vehicleModelTrimId: trimId,
        licenseNumber: vehicle?.licenseNumber,
        provinceId: vehicle?.provinceId || vehicle?.provinceObject?._id,
    };
    if (isFleet) {
        data.fleetUnitNumber = vehicle?.fleetUnitNumber || '';
    }
    if (vehicle?.vin) {
        data.vin = vehicle.vin;
    }
    return data;
};

// Formats a postal/zip code the same way the Postal Code field does while typing,
// so values coming back from the API pass the same length validation.
const formatPostalCode = (value, country) => {
    if (!value) return '';
    const isUSA = country?.country === 'United States';
    if (isUSA) return value.replace(/\D/g, '').slice(0, 5);
    const cleaned = value.replace(/\s/g, '').toUpperCase().slice(0, 6);
    return cleaned.length > 3 ? cleaned.slice(0, 3) + ' ' + cleaned.slice(3) : cleaned;
};

const styles = {
    label: {
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '20px',
        marginBottom: '8px',
        color: '#212121',
    },
    phoneTypeSelect: {
        ...MuiSelectWithFocus,
        '& .MuiSelect-icon': {
            right: '8px !important',
        },
        '& .MuiSelect-select': {
            width: '70px',
            paddingLeft: '12px!important',
            paddingRight: '12px!important',
        },
    },
    phoneTypeMenuProps: {
        PaperProps: {
            style: {
                width: '140px',
                marginTop: '2px',
                marginLeft: '34px',
                boxShadow: '0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 5px 5px -3px rgba(0, 0, 0, 0.20)',
                borderRadius: '4px',
            },
        },
    },
    countrySelect: {
        width: 'auto',
        minWidth: 'auto',
        height: '50px',
        border: 'none',
        marginRight: '8px',
        boxShadow: 'none',
    },
    countrySelectMenuProps: {
        PaperProps: {
            style: {
                width: '264px',
                marginLeft: '86px',
                boxShadow: '0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.20)',
            },
        },
    },
    countrySelectSx: {
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        '& .MuiSelect-select': {
            paddingLeft: '0px',
            paddingRight: '32px !important',
            marginRight: '0!important',
            display: 'flex',
            alignItems: 'center',
            gap: '0',
        },
        background: 'transparent',
    },
    flagContainer: {
        width: '22px',
        height: '16px',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
        fontSize: '20px',
    },
    welcomeText: {
        fontSize: '14px',
        lineHeight: '120%',
        letterSpacing: '0.15px',
        fontStyle: 'italic',
    },
};

const PhoneField = ({
    label,
    isRequired,
    phoneTypeFieldName,
    phoneNumberFieldName,
    control,
    errors,
    setValue,
    setError,
    clearErrors,
    selectedPhoneTypes,
    setSelectedPhoneTypes,
    phoneTypeKey,
    selectedCountry,
    handleCountryChange,
    countryList,
    phoneInputRef,
    phoneTypes,
    checkPhoneNumberExist,
    isCheckingPhone,
    showCustomerFoundMessage,
    setShowCustomerFoundMessage,
}) => {
    return (
        <Stack spacing={0}>
            <Typography variant="body1" style={styles.label}>
                {label} {isRequired && <span style={{ color: REQUIRED_RED }}>*</span>}
            </Typography>

            <Stack direction="row" spacing={1}>
                {/* Phone Type Dropdown */}
                <FormControl>
                    <Controller
                        name={phoneTypeFieldName}
                        control={control}
                        render={({ field }) => (
                            <MuiSelect
                                value={selectedPhoneTypes?.[phoneTypeKey] || 'mobile'}
                                onChange={(e) => {
                                    setSelectedPhoneTypes({
                                        ...selectedPhoneTypes,
                                        [phoneTypeKey]: e.target.value,
                                    });
                                    field.onChange(e.target.value);
                                }}
                                MenuProps={styles.phoneTypeMenuProps}
                                sx={styles.phoneTypeSelect}
                                renderValue={(selected) => {
                                    const selectedType = phoneTypes.find((type) => type.key === selected);
                                    return (
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'flex-start',
                                                padding: '3px 7px',
                                                width: '38px',
                                                height: '38px',
                                            }}
                                        >
                                            {PhoneTypeIcon(selectedType?.key || 'mobile')}
                                        </div>
                                    );
                                }}
                            >
                                {phoneTypes.map((type) => (
                                    <MenuItem
                                        key={type.key}
                                        value={type.key}
                                        sx={{
                                            gap: 0.5,
                                            paddingTop: '0',
                                            paddingBottom: '0',
                                            paddingLeft: '8px',
                                            paddingRight: '8px',
                                            marginBottom: '0',
                                            fontWeight: 400,
                                            color: '#212121',
                                            lineHeight: '130%',
                                        }}
                                    >
                                        <div style={{ width: '38px', height: '38px', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                                            {PhoneTypeIcon(type.key)}
                                        </div>{' '}
                                        {type.value}
                                    </MenuItem>
                                ))}
                            </MuiSelect>
                        )}
                    />
                </FormControl>

                {/* Phone Number Input */}
                <Controller
                    name={phoneNumberFieldName}
                    control={control}
                    rules={
                        isRequired
                            ? {
                                  required: 'Phone Number is required',
                                  pattern: {
                                      value: /^\d{3}-\d{3}-\d{4}$/,
                                      message: 'Phone number should be 10 digits long',
                                  },
                              }
                            : {
                                  pattern: {
                                      value: /^\d{3}-\d{3}-\d{4}$/,
                                      message: 'Phone number should be 10 digits long',
                                  },
                              }
                    }
                    render={({ field }) => (
                        <TextField
                            InputProps={{
                                startAdornment: (
                                    <MuiSelect
                                        style={styles.countrySelect}
                                        MenuProps={styles.countrySelectMenuProps}
                                        sx={styles.countrySelectSx}
                                        value={selectedCountry?._id ?? ''}
                                        onChange={handleCountryChange}
                                        renderValue={(selected) => {
                                            const country = countryList.find((item) => item._id === selected) || selectedCountry;
                                            if (!country) return 'Select';
                                            return (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <div style={styles.flagContainer}>{country.flag}</div>
                                                    <span style={{ fontSize: '16px', fontWeight: 400 }}>{country.dial_code}</span>
                                                </div>
                                            );
                                        }}
                                        IconComponent={UnfoldMoreIcon}
                                    >
                                        {countryList?.length > 0 &&
                                            countryList.map((country) => (
                                                <MenuItem key={country._id} value={country._id} style={{ height: '44px' }}>
                                                    <span style={{ marginRight: '8px' }}>
                                                        <img src={country?.flag_svg} alt="flag" style={{ width: '24px', height: '12px' }} />
                                                    </span>
                                                    {country.country} ({country.dial_code})
                                                </MenuItem>
                                            ))}
                                    </MuiSelect>
                                ),
                                endAdornment: isCheckingPhone && (
                                    <div style={{ width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <CircularProgress size={20} />
                                    </div>
                                ),
                            }}
                            inputRef={phoneInputRef ? (el) => (phoneInputRef.current = el) : null}
                            sx={{
                                ...MuiTextFieldWithFocus,
                                '& .MuiInputBase-root': {
                                    marginRight: '0!important',
                                    borderRadius: '8px',
                                    boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
                                    height: '50px',
                                },
                            }}
                            variant="outlined"
                            fullWidth
                            error={!!errors[phoneNumberFieldName]}
                            helperText={errors[phoneNumberFieldName] ? errors[phoneNumberFieldName].message : ''}
                            {...field}
                            onChange={(e) => {
                                if (removeDashFromPhoneNumber(e.target.value).length <= 10) {
                                    const input = e.target;
                                    const rawValue = e.target.value;
                                    const prevCursorPosition = input.selectionStart;
                                    const isDeleting = e.nativeEvent.inputType === 'deleteContentBackward';
                                    const formattedValue = inputFormatPhoneNumber(rawValue);

                                    setValue(phoneNumberFieldName, formattedValue);

                                    const hyphenCountBefore = (rawValue.match(/-/g) || []).length;
                                    const hyphenCountAfter = (formattedValue.match(/-/g) || []).length;
                                    let newCursorPosition = prevCursorPosition;
                                    if (isDeleting && hyphenCountAfter < hyphenCountBefore) newCursorPosition--;
                                    else if (!isDeleting && hyphenCountAfter > hyphenCountBefore) newCursorPosition++;
                                    newCursorPosition = Math.max(0, Math.min(newCursorPosition, formattedValue.length));

                                    setTimeout(() => {
                                        input.setSelectionRange(newCursorPosition, newCursorPosition);
                                    }, 0);

                                    const cleanLength = removeDashFromPhoneNumber(e.target.value).length;
                                    if (cleanLength < 10) {
                                        if (phoneNumberFieldName === 'phoneNumber' && setShowCustomerFoundMessage) {
                                            setShowCustomerFoundMessage(false);
                                        }
                                        if (cleanLength > 0 || isRequired) {
                                            setError(phoneNumberFieldName, {
                                                message: 'Phone Number should be 10 digits',
                                            });
                                        } else {
                                            clearErrors(phoneNumberFieldName);
                                        }
                                    } else {
                                        clearErrors(phoneNumberFieldName);
                                        if (phoneNumberFieldName === 'phoneNumber' && checkPhoneNumberExist) {
                                            checkPhoneNumberExist(selectedCountry);
                                        }
                                    }
                                }
                            }}
                            onKeyDown={(e) => {
                                preventPhoneInputKeys(e);
                            }}
                        />
                    )}
                />
            </Stack>
        </Stack>
    );
};

const CustomTextField = ({ label, isRequired, name, control, errors, rules, clearErrors }) => {
    return (
        <Stack spacing={0}>
            <Typography variant="body1" style={styles.label}>
                {label} {isRequired && <span style={{ color: REQUIRED_RED }}>*</span>}
            </Typography>
            <Controller
                name={name}
                control={control}
                rules={rules}
                render={({ field }) => (
                    <TextField
                        fullWidth
                        variant="outlined"
                        sx={MuiTextFieldWithFocus}
                        error={!!errors[name]}
                        helperText={errors[name] ? errors[name].message : ''}
                        {...field}
                        onChange={(e) => {
                            let value = e.target.value;

                            if (name === 'firstName' || name === 'lastName') {
                                value = value.replace(/\b\w/g, (char) => char.toUpperCase());
                            }
                            field.onChange(value);
                            if (errors[name]) {
                                clearErrors(name);
                            }
                        }}
                    />
                )}
            />
        </Stack>
    );
};

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};

const NewCustomers = () => {
    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }
    const {
        handleSubmit,
        control,
        setValue,
        formState: { errors },
        getValues,
        setError,
        setFocus,
        clearErrors,
        reset,
        watch,
    } = useForm({
        defaultValues: {
            primaryPhoneNumberType: {
                key: 'mobile',
                value: 'Mobile',
            },
            secondaryPhoneNumberType: {
                key: 'mobile',
                value: 'Mobile',
            },
            isFleetCustomer: false,
            taxExemptionNumber: '',
        },
    });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isFleetCustomer, setIsFLeetCustomer] = useState(false);
    const [vehicles, setVehicles] = useState([]);
    const [completeAddress, setCompleteAddress] = useState({});
    const [discountId, setDiscountId] = useState('');
    const [placeId, setPlaceId] = useState('');
    const [open, setOpen] = React.useState(false);

    const [isDeleteModal, setIsDeleteModal] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);

    const [editVehicle, setEditVehicle] = useState({
        edit: false,
        editIndex: '',
    });
    const [notes, setNotes] = useState([]);
    const [discountList, setDiscountList] = useState([]);
    const [noteError, setNoteError] = useState(false);
    const [newNote, setNewNote] = useState('');
    const [sendWelcomeEmailToCustomer, setSendWelcomeEmailToCustomer] = useState(true);
    const [showCustomerFoundMessage, setShowCustomerFoundMessage] = useState(false);

    const { data: shopConfigData } = useGetShopConfig();

    // Hydrate sendWelcomeEmailToCustomer from shop config API
    useEffect(() => {
        const config = shopConfigData?.config || shopConfigData;
        if (config && config.defaultSendWelcomeEmailToCustomer !== undefined) {
            setSendWelcomeEmailToCustomer(Boolean(config.defaultSendWelcomeEmailToCustomer));
        }
    }, [shopConfigData]);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open1 = Boolean(anchorEl);
    const theme = useTheme();

    const phoneInputRef = useRef(null);

    const shopCountryId = localStorage.getItem('shopCountryId') || '64e738882fec8f2c9b79c139';

    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedCountrySecondary, setSelectedCountrySecondary] = useState(null);

    const { data: countryList, isLoading: countryListLoader } = useGetCountryMasterList(
        { countryId: shopCountryId },
        { enabled: !!shopCountryId, ...masterQueryOptions }
    );
    const { data: provinceList, isLoading: provinceListLoader } = useGetProvinceMasterList(
        { countryId: selectedCountry?._id },
        { enabled: !!selectedCountry?._id, ...masterQueryOptions }
    );
    const {
        data: cityList,
        isLoading: cityListLoader,
        refetch: fetchCityList,
    } = useGetCityMasterList({ countryId: selectedCountry?._id }, { enabled: !!selectedCountry?._id, ...masterQueryOptions });

    const [showNotesUI, setShowNotesUI] = React.useState(false);
    const [showAdditionalDetailUI, setShowAdditionalDetailUI] = React.useState(false);

    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [openSuccessModal, setOpenSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [selectedActionOfNote, setSelectedActionOfNote] = useState('');
    const [editDeleteNoteId, setEditDeleteNoteId] = useState('');
    const [editNoteText, setEditNoteText] = useState('');
    const [getAddress, setAddress] = useState();
    const [recordFoundByPhone, setRecordFoundByPhone] = useState({
        id: '',
        found: false,
        isShopImported: false,
    });
    const [addressValues, setAddressValue] = useState({
        street_number: '',
        city: '',
        province: '',
        postal: '',
        country: '',
        provinceId: '',
        cityId: '',
        streetAddress: '',
    });
    const [discountProgramLoader, setDiscountProgramLoader] = useState(false);
    const [phoneTypes, setPhoneTypes] = useState(PHONE_TYPES);
    const [selectedPhoneTypes, setSelectedPhoneTypes] = useState({
        primary: 'mobile',
        secondary: 'mobile',
    });
    const [contactPrefrences, setContactPrefrences] = useState(CONTACT_PREFRENCES);

    const [primaryEmailIndex, setPrimaryEmailIndex] = useState(0);
    const [error, setErrors] = useState({});

    const [triggerSelection, setTriggerSelection] = useState(null);
    const watchedProvince = watch('province');

    // City Autocomplete Optimization (Chunked Loading)
    const [cityInputValue, setCityInputValue] = useState('');
    const [filteredCityOptions, setFilteredCityOptions] = useState([]);
    const [displayedCityOptions, setDisplayedCityOptions] = useState([]);
    const [cityLoadIndex, setCityLoadIndex] = useState(1);
    const itemsPerLoad = 100;

    // Filter and chunk city list
    useEffect(() => {
        if (!cityList?.length) {
            setFilteredCityOptions([]);
            setDisplayedCityOptions([]);
            return;
        }

        const searchTerm = cityInputValue.toLowerCase().trim();

        // If input is empty or too short, show all (chunked)
        if (searchTerm.length < 2) {
            setFilteredCityOptions(cityList);
            setDisplayedCityOptions(cityList.slice(0, itemsPerLoad * cityLoadIndex));
            return;
        }

        // Filter based on search
        const filtered = cityList.filter((city) => city.city?.toLowerCase().includes(searchTerm));

        setFilteredCityOptions(filtered);
        setDisplayedCityOptions(filtered.slice(0, itemsPerLoad * cityLoadIndex));
    }, [cityList, cityInputValue, cityLoadIndex]);

    const handleCityScroll = (event) => {
        const listboxNode = event.currentTarget;
        const bottomReached = listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 20;

        if (bottomReached && displayedCityOptions.length < filteredCityOptions.length) {
            setCityLoadIndex((prev) => prev + 1);
        }
    };

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setEditVehicle({ edit: false, editIndex: '' });
    };
    const handleClickNoteActions = (event, data) => {
        setAnchorEl(event.currentTarget);
        setSelectedActionOfNote(data);
    };
    const handleCloseNoteActions = () => {
        setAnchorEl(null);
        setSelectedActionOfNote('');
    };

    const handleDeleteVehicleByAPI = async (id) => {
        return await dispatch(deleteCustomerVehicle(id));
    };

    const handleDeleteVehicle = async (index) => {
        const data = vehicles[index];
        if (data?.vehcileId) {
            const resp = await handleDeleteVehicleByAPI(data?.vehcileId);
            if (resp) {
                const filteredData = vehicles?.filter((d) => d != data);
                setVehicles(filteredData);
            }
            // console.log("resp",resp);
        } else {
            const filteredData = vehicles?.filter((d) => d != data);
            // console.log("filteredData", filteredData);
            setVehicles(filteredData);
        }
        handleClose();
    };

    const handleConfirmDelete = async () => {
        if (deleteIndex === null) {
            setIsDeleteModal(false);
            return;
        }

        const vehicle = vehicles[deleteIndex];

        // Only vehicles that already exist server-side need an API call; a vehicle added
        // in this session lives in local state until the customer is saved.
        if (vehicle?.vehcileId) {
            setShowLoader(true);
            try {
                if (recordFoundByPhone?.isShopImported) {
                    await deleteImportedVehicleApi(vehicle.vehcileId);
                } else {
                    await handleDeleteVehicleByAPI(vehicle.vehcileId);
                }
            } catch (error) {
                console.error('Error deleting vehicle:', error);
                toast.error('Failed to delete vehicle');
                setShowLoader(false);
                setDeleteIndex(null);
                setIsDeleteModal(false);
                return;
            }
            setShowLoader(false);
        }

        setVehicles((prev) => prev.filter((_, i) => i !== deleteIndex));
        setDeleteIndex(null);
        setIsDeleteModal(false);
    };

    const handleAddNote = async () => {
        if (!newNote) {
            return setNoteError(true);
        }
        setNoteError(false);

        setNotes([...notes, { note: newNote, createdAt: new Date() }]);
        setNewNote('');
    };

    const deleteNote = (selectedActionOfNote) => {
        setNotes(notes.filter((note) => note !== selectedActionOfNote));
    };

    const handleEditNote = () => {
        // console.log("notes", notes, editDeleteNoteId);
        const allNotes = [...notes];
        let findIndex = allNotes.indexOf(editDeleteNoteId);
        // console.log("findIndex", findIndex);
        let data = { ...allNotes[findIndex], note: editNoteText.trim() };
        allNotes[findIndex] = data;
        // allNotes[0].note="sdsds"
        setNotes(allNotes);
        setSelectedActionOfNote('');
        setEditDeleteNoteId('');
        setEditNoteText('');
    };

    useEffect(() => {
        fetchDiscountProgram();
        // Focus to end of text after state update
        setTimeout(() => {
            if (phoneInputRef.current) {
                phoneInputRef.current.focus();
            }
        }, 0);
    }, []);

    useEffect(() => {
        if (countryList && countryList.length > 0) {
            const selected = countryList.find((item) => item.default === true);
            setSelectedCountry(selected);
            setSelectedCountrySecondary(selected);
            setAddressValue({
                ...addressValues,
                countryId: selected?._id,
            });
        }
    }, [countryList]);

    const fetchDiscountProgram = async () => {
        setDiscountProgramLoader(true);
        let resp = await dispatch(discountProgramApi({ pagination: false }));
        if (resp.length > 0) {
            setDiscountList(resp);
        }
        setDiscountProgramLoader(false);
    };

    // console.log("complete address", completeAddress);
    const handleCountryChange = (event) => {
        const selected = countryList.find((item) => item._id === event.target.value);
        const countryChanged = selected?._id !== selectedCountry?._id;
        setSelectedCountry(selected);

        // Province, city and postal code are all country-scoped - keeping the old
        // country's values would submit e.g. an Ontario province id against the USA.
        if (countryChanged) {
            setValue('province', '');
            setValue('city', '');
            setValue('postalCode', '');
            setCityInputValue('');
            clearErrors(['province', 'city', 'postalCode']);
            setErrors({});
            setAddressValue((prev) => ({
                ...prev,
                countryId: selected?._id,
                province: '',
                provinceId: '',
                city: '',
                cityId: '',
                postal: '',
            }));
        }

        checkPhoneNumberExist(selected);
        if (triggerSelection === null) {
            setTriggerSelection(true);
        } else {
            setTriggerSelection(!triggerSelection);
        }
    };

    const handleCountryChangeSecondary = (event) => {
        const selected = countryList.find((item) => item._id === event.target.value);
        setSelectedCountrySecondary(selected);
    };
    const onSubmit = async (values) => {
        if (vehicles && vehicles.length > 0) {
            for (let i = 0; i < vehicles.length; i++) {
                const vehicle = vehicles[i];
                const yearVal = vehicle?.year ? (vehicle.year + '').trim() : '';
                const makeId = vehicle?.vehicleMakeId?._id || (typeof vehicle?.vehicleMakeId === 'string' ? vehicle?.vehicleMakeId : undefined);
                const modelId = vehicle?.vehicleModelId?._id || (typeof vehicle?.vehicleModelId === 'string' ? vehicle?.vehicleModelId : undefined);

                if (!yearVal) {
                    toast.error('Vehicle year is required');
                    return;
                }
                if (!makeId) {
                    toast.error('Vehicle make is required');
                    return;
                }
                if (!modelId) {
                    toast.error('Vehicle model is required');
                    return;
                }
            }
        }

        let payload = {
            // values.phoneNumber  = values.phoneNumber.replace(/-/g, ""),

            notes: [],
            vehicle: [],
            isFleetCustomer: isFleetCustomer || false,
        };
        if (!recordFoundByPhone?.found) {
            payload.sendWelcomeEmailToCustomer = sendWelcomeEmailToCustomer || false;
        }
        for (const key in values) {
            if (values[key]) payload[key] = values[key];
        }

        if (values.email) {
            payload.email = values.email;
        }
        if (values.secondaryEmail) {
            payload.secondaryEmail = values.secondaryEmail;
        }

        if (values.firstName) {
            payload.firstName = values.firstName.trim();
        }

        if (values.lastName) {
            payload.lastName = values.lastName.trim();
        }

        if (recordFoundByPhone?.found) {
            if (values.lastName) {
                payload.lastName = values.lastName;
            } else {
                payload.lastName = '';
            }
        }

        if (selectedCountry?._id) {
            payload.country = selectedCountry._id;
        }

        if (values?.streetAddress) {
            payload.streetAddress = values?.streetAddress;
        }
        if (values?.taxExemptionNumber) {
            payload.taxExemptionNumber = values?.taxExemptionNumber.trim();
        }
        if (values?.city) {
            payload.city = values.city;
        }
        if (values?.province) {
            payload.province = values.province;
        }
        if (values?.postalCode) {
            payload.postalCode = values?.postalCode;
        }
        // if (values?.contactPrefrence) {
        //   payload.contactPrefrence = values?.contactPrefrence?.key;
        // } else {
        //   delete payload["contactPrefrence"];
        // }
        // Normalize phone type: form may have object { key, value } (defaults) or direct string ('mobile', 'work', etc.) from select
        // const getPhoneTypeKey = (val) => {
        //     if (val == null || val === '') return undefined;
        //     return typeof val === 'object' && val !== null && 'key' in val ? val.key : val;
        // };

        if (values?.primaryPhoneNumberType) {
            payload.primaryPhoneNumberType = values.primaryPhoneNumberType?.key || values.primaryPhoneNumberType; // already a string
            payload.countryCode = selectedCountry?.dial_code;
            payload.phoneNumberCountry = selectedCountry?._id;
        }

        if (values?.secondaryPhoneNumberType) {
            payload.secondaryPhoneNumberType = values.secondaryPhoneNumberType?.key || values.secondaryPhoneNumberType; // already a string
        }

        if (values?.secondaryPhoneNumber && values.secondaryPhoneNumber !== '') {
            payload.secondaryPhoneNumberCountryCode = selectedCountrySecondary?.dial_code;
            payload.secondaryPhoneNumberCountry = selectedCountrySecondary?._id;
        } else {
        }

        notes?.map((notee) => {
            payload.notes.push({ notes: notee?.note });
        });
        if (recordFoundByPhone?.found) {
            delete payload['notes'];
        } else {
            // email field delete for new customer create if email is empty
            if (payload.email == '') delete payload['email'];
        }

        vehicles?.forEach((vehicle) => {
            const data = buildVehicleApiPayload(vehicle, isFleetCustomer);
            if (vehicle?.vehcileId) {
                data.vehicleId = vehicle?.vehcileId;
            }
            payload?.vehicle.push(data);
        });
        if (discountId && discountId !== '' && discountId !== 'none') {
            payload.membershipProgram = discountId;
        } else {
            payload.membershipProgram = '';
        }
        // console.log("🚀 ~ onSubmit ~ payload:", payload);

        setShowLoader(true);

        // A phone match on a shop_imported record is not a normal update - that record has to go
        // through the conversion endpoint, which creates the shop_created customer from it.
        if (recordFoundByPhone?.found && recordFoundByPhone?.isShopImported) {
            const importedPayload = { ...payload, importShopCustomerId: recordFoundByPhone?.id };
            // The conversion endpoint owns neither of these
            delete importedPayload.vehicle;
            delete importedPayload.notes;
            if (!importedPayload.membershipProgram) {
                delete importedPayload.membershipProgram;
            }

            const importedResp = await dispatch(shopImportedCustomerCreate(filterUndefined(importedPayload)));

            if (importedResp?.data?._id) {
                const convertedCustomerId = importedResp.data._id;

                // The conversion endpoint takes no vehicle array, so vehicles added during this
                // session (no server id yet) are created against the new shop_created customer.
                const newVehicles = (vehicles || []).filter((v) => !v?.vehcileId);
                for (const vehicle of newVehicles) {
                    try {
                        await createVehicleApi({ ...buildVehicleApiPayload(vehicle, isFleetCustomer), customerId: convertedCustomerId });
                    } catch (error) {
                        console.error('Error creating vehicle after conversion:', error);
                        toast.error('Customer saved, but a vehicle could not be added');
                    }
                }

                navigate(`/customers/${convertedCustomerId}/shop_created`);
                setOpenSuccessModal(true);
                setSuccessMessage('Customer information confirmed successfully.');
            } else {
                toast.error('Failed to confirm customer information');
            }
            setShowLoader(false);
            return;
        }

        let resp;
        recordFoundByPhone?.found
            ? (resp = await dispatch(updatePhoneNumberExistCustomer(recordFoundByPhone?.id, payload)))
            : (resp = await dispatch(customerCreate(payload)));
        if (resp) {
            navigate(`/customers/${resp?._id}/shop_created`);
            setOpenSuccessModal(true);
            setSuccessMessage(`Customer ${recordFoundByPhone?.found ? 'Updated' : 'Created'}`);
        }
        setShowLoader(false);
    };

    const checkPhoneNumberExist = async (selected) => {
        setShowLoader(true);
        var phoneNumberWithoutDashes = getValues()?.phoneNumber?.replace(/-/g, '');

        // console.log("phoneNumberWithoutDashes",phoneNumberWithoutDashes);

        if (!phoneNumberWithoutDashes || phoneNumberWithoutDashes?.length < 10) {
        } else {
            const res = await dispatch(
                customerCheckPhoneNumberExist({
                    phoneNumber: phoneNumberWithoutDashes,
                    countryCode: selected?.dial_code,
                    phoneNumberCountry: selected?._id,
                })
            );
            if (res.status) {
                console.log('🚀 ~ checkPhoneNumberExist ~ res:', res);
                setRecordFoundByPhone({ id: res?.data?._id, found: true, isShopImported: res?.data?.shopImported || false });
                setShowCustomerFoundMessage(true);
                setValue('firstName', res?.data?.firstName);
                setValue('lastName', res?.data?.lastName);
                setValue('email', res?.data?.email);
                setValue('company', res?.data?.company);

                if (res?.data?.primaryPhoneNumberType) {
                    setValue('primaryPhoneNumberType', res.data.primaryPhoneNumberType);
                    setSelectedPhoneTypes((prev) => ({
                        ...prev,
                        primary: res.data.primaryPhoneNumberType,
                    }));
                }

                if (res?.data?.secondaryPhoneNumberType) {
                    setValue('secondaryPhoneNumberType', res.data.secondaryPhoneNumberType);
                    setSelectedPhoneTypes((prev) => ({
                        ...prev,
                        secondary: res.data.secondaryPhoneNumberType,
                    }));
                    const formatted = inputFormatPhoneNumber(res.data.secondaryPhoneNumber);
                    setValue('secondaryPhoneNumber', formatted);
                }

                if (res?.data?.isFleetCustomer) {
                    setShowAdditionalDetailUI(true);
                    setIsFLeetCustomer(true);
                }

                // Pre-fill address (same pattern as AddCustomerModalV4)
                if (res?.data?.streetAddress) setValue('streetAddress', res.data.streetAddress);
                if (res?.data?.city) {
                    const cityId = res.data.city?._id || res.data.city;
                    setValue('city', cityId);
                    setCityInputValue(res.data.city?.city || res.data.city?.name || '');
                }
                if (res?.data?.province) {
                    const provinceId = res.data.province?._id || res.data.province;
                    setValue('province', provinceId);
                    if (provinceId) fetchCityList();
                }
                if (res?.data?.postalCode) setValue('postalCode', formatPostalCode(res.data.postalCode, res?.data?.country || selected));
                if (res?.data?.taxExemptionNumber) setValue('taxExemptionNumber', res.data.taxExemptionNumber);

                // Keep addressValues in sync for any logic that depends on it
                setAddressValue((prev) => ({
                    ...prev,
                    streetAddress: res?.data?.streetAddress ?? prev.streetAddress,
                    street_number: res?.data?.street_number ?? prev.street_number,
                    city: res?.data?.city?.city ?? res?.data?.city?.name ?? prev.city,
                    province: res?.data?.province?.province ?? res?.data?.province ?? prev.province,
                    postal: res?.data?.postalCode ?? prev.postal,
                    provinceId: res?.data?.province?._id ?? res?.data?.province ?? prev.provinceId,
                    cityId: res?.data?.city?._id ?? res?.data?.city ?? prev.cityId,
                }));

                // Show Additional Details when we have address or company so user sees pre-filled data
                if (res?.data?.streetAddress || res?.data?.city || res?.data?.province || res?.data?.postalCode || res?.data?.company) {
                    setShowAdditionalDetailUI(true);
                }

                setVehicles((res?.data?.vehicleData || []).map(mapApiVehicleToLocal));
            } else {
                setRecordFoundByPhone({ id: '', found: false, isShopImported: false });
                setShowCustomerFoundMessage(false);
                // setValue("firstName", "");
                // setValue("lastName", "");
                // setValue("email", "");
                // setValue("company", "");

                // setCompleteAddress({});
                // setAddress(" ");
                // setValue("city", "");
                // setValue("province", "");
                // setValue("postalCode", "");
                // setValue("country", "");
                // setValue("streetAddress", "");
                // setVehicles([]);
                let allVehciles = [...vehicles];
                allVehciles.map((v, key) => {
                    if (v?.vehcileId) {
                        delete v['vehcileId'];
                    }
                });
                setVehicles(allVehciles);
            }
        }
        setShowLoader(false);
    };
    const validatePhoneNumber = (number) => {
        const numericValue = number.replace(/\D/g, '');
        return numericValue.length === 10;
    };

    const validate = () => {
        const newErrors = {};
        const postalValue = getValues('postalCode');

        if (postalValue) {
            const isUSA = selectedCountry?.country === 'United States';
            // Compare on the unformatted value so an API-prefilled 'L6X0Y1' is as valid as a typed 'L6X 0Y1'
            const bareValue = postalValue.replace(/\s/g, '');
            const isValidLength = isUSA ? bareValue.length === 5 : bareValue.length === 6;

            if (!isValidLength) {
                const errorMessage = isUSA ? 'Zip code is required - 5 digits' : 'Postal code is required - 6 digits';
                newErrors.postalCode = { message: errorMessage };
            }
        }

        setErrors(newErrors);
        console.log('NewErrors: ', newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault(); // Prevent default tab behavior
        }
    };

    const onInvalid = (errors) => {
        const firstErrorField = Object.keys(errors)[0];
        console.log('🚀 ~ onInvalid ~ firstErrorField:', firstErrorField);
        if (firstErrorField) {
            const errorElement = document.querySelector(`[name=${firstErrorField}]`);
            if (errorElement) {
                errorElement.scrollIntoView({ behavior: 'smooth' });
                setTimeout(() => {
                    const offset = 100; // Adjust the offset value as needed
                    const elementPosition = errorElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition - offset;
                    window.scrollBy({ top: offsetPosition, behavior: 'smooth' });
                    setFocus(firstErrorField);
                }, 0);
            }
        }
    };

    return (
        <>
            <Box padding={'32px 24px'}>
                <Grid container sx={{ padding: '16px 0px' }} gap={'8px'}>
                    <Grid item lg={12} md={12} sm={12} xs={12} paddingBottom={'8px'}>
                        <div role="presentation" onClick={handleClick}>
                            <Breadcrumbs aria-label="breadcrumb">
                                <Link
                                    to="/customers"
                                    style={{
                                        color: 'black',
                                        opacity: '0.6',
                                        textDecoration: 'none',
                                    }}
                                >
                                    Customers
                                </Link>
                                <Link to="/customers/new-customer" style={{ color: 'black', textDecoration: 'none' }}>
                                    New Customer
                                </Link>
                            </Breadcrumbs>
                        </div>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} fontWeight={'bold'}>
                        <Typography sx={{ fontSize: '34px', fontWeight: 500 }}>New Customer</Typography>
                    </Grid>
                </Grid>
                <form onSubmit={handleSubmit(onSubmit, onInvalid)}>
                    <Grid container boxShadow={3} borderTop={'none'} padding={'24px'} borderRadius={'10px'} marginTop={'32px'} bgcolor={'white'}>
                        <Grid item xs={12} sm={12} md={3} xl={3}>
                            <Typography variant="h5" sx={{ fontWeight: 400, fontSize: '24px' }}>
                                Basic Details
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={9} xl={9}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <PhoneField
                                        label="Primary Phone"
                                        isRequired={true}
                                        phoneTypeFieldName="primaryPhoneNumberType"
                                        phoneNumberFieldName="phoneNumber"
                                        control={control}
                                        errors={errors}
                                        setValue={setValue}
                                        setError={setError}
                                        clearErrors={clearErrors}
                                        selectedPhoneTypes={selectedPhoneTypes}
                                        setSelectedPhoneTypes={setSelectedPhoneTypes}
                                        phoneTypeKey="primary"
                                        selectedCountry={selectedCountry}
                                        handleCountryChange={handleCountryChange}
                                        countryList={countryList}
                                        phoneInputRef={phoneInputRef}
                                        phoneTypes={phoneTypes}
                                        checkPhoneNumberExist={checkPhoneNumberExist}
                                        isCheckingPhone={showLoader}
                                        showCustomerFoundMessage={showCustomerFoundMessage}
                                        setShowCustomerFoundMessage={setShowCustomerFoundMessage}
                                    />
                                    {showCustomerFoundMessage && (
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                color: '#d32f2f',
                                                fontStyle: 'italic',
                                                fontSize: '0.875rem',
                                                marginTop: '4px',
                                                display: 'block',
                                            }}
                                        >
                                            Details auto-filled from Apex. Review and save to add
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <PhoneField
                                        label="Secondary Phone"
                                        isRequired={false}
                                        phoneTypeFieldName="secondaryPhoneNumberType"
                                        phoneNumberFieldName="secondaryPhoneNumber"
                                        control={control}
                                        errors={errors}
                                        setValue={setValue}
                                        setError={setError}
                                        clearErrors={clearErrors}
                                        selectedPhoneTypes={selectedPhoneTypes}
                                        setSelectedPhoneTypes={setSelectedPhoneTypes}
                                        phoneTypeKey="secondary"
                                        selectedCountry={selectedCountrySecondary}
                                        handleCountryChange={handleCountryChangeSecondary}
                                        countryList={countryList}
                                        phoneTypes={phoneTypes}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <CustomTextField
                                        label="First Name"
                                        isRequired={true}
                                        name="firstName"
                                        control={control}
                                        errors={errors}
                                        rules={{ required: 'First name is required' }}
                                        clearErrors={clearErrors}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <CustomTextField
                                        label="Last Name"
                                        isRequired={false}
                                        name="lastName"
                                        control={control}
                                        errors={errors}
                                        clearErrors={clearErrors}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Stack spacing={1}>
                                        <CustomTextField
                                            label="Primary Email"
                                            isRequired={false}
                                            name="email"
                                            control={control}
                                            errors={errors}
                                            rules={{
                                                pattern: {
                                                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                    message: 'Please enter valid email address',
                                                },
                                            }}
                                            clearErrors={clearErrors}
                                        />
                                        <Stack flexDirection={'row'} gap={1} alignItems={'center'} sx={{ mt: 1 }}>
                                            <Switch
                                                checked={sendWelcomeEmailToCustomer}
                                                onChange={() => {
                                                    setSendWelcomeEmailToCustomer(!sendWelcomeEmailToCustomer);
                                                }}
                                                color="primary"
                                                size="small"
                                            />
                                            <Stack flexDirection={'row'} width={'100%'} alignItems={'center'}>
                                                <Typography sx={{ ...styles.welcomeText, marginRight: '2px' }}>Send Welcome to</Typography> <ApexAutoSvg />
                                                <Typography sx={{ ...styles.welcomeText, marginLeft: '0.7px' }}>Apex Auto App email</Typography>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <CustomTextField
                                        label="Secondary Email"
                                        isRequired={false}
                                        name="secondaryEmail"
                                        control={control}
                                        errors={errors}
                                        rules={{
                                            pattern: {
                                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                message: 'Please enter valid email address',
                                            },
                                        }}
                                        clearErrors={clearErrors}
                                    />
                                </Grid>

                                <Grid item xs={12} md={12}>
                                    <Typography variant="body1" style={styles.label}>
                                        Contact Preference
                                    </Typography>
                                    <Controller
                                        name="contactPrefrence"
                                        control={control}
                                        render={({ field }) => (
                                            <StyledToggleButtonGroup
                                                value={field.value}
                                                exclusive
                                                onBlur={field.onBlur}
                                                onChange={(_, value) => field.onChange(value)}
                                                aria-label="contact preference"
                                                sx={{ gap: 2 }}
                                            >
                                                {CONTACT_PREFRENCES?.map((preference) => {
                                                    const displayLabel =
                                                        preference.key === 'callOnPhone'
                                                            ? 'Phone Call'
                                                            : preference.key === 'inAppMessages'
                                                              ? 'Text'
                                                              : preference.key === 'email'
                                                                ? 'Email'
                                                                : preference.value;

                                                    return (
                                                        <StyledToggleButton key={preference.key} value={preference.key}>
                                                            {displayLabel}
                                                        </StyledToggleButton>
                                                    );
                                                })}
                                            </StyledToggleButtonGroup>
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {showAdditionalDetailUI && (
                        <Grid
                            container
                            sx={{ boxShadow: 3 }}
                            justifyContent={'start'}
                            borderTop={'none'}
                            padding={'24px'}
                            borderRadius={'10px'}
                            marginTop={'32px'}
                            bgcolor={'white'}
                        >
                            <Grid item xs={12} sm={12} md={3} xl={3}>
                                <Typography variant="h5" sx={{ fontWeight: 400, fontSize: '24px' }}>
                                    Additional Details
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={9} xl={9}>
                                <Grid container spacing={3}>
                                    {/* Row 1: Company and Fleet */}
                                    <Grid item xs={12} md={6}>
                                        <Stack spacing={0}>
                                            <Typography sx={{ ...styles.label, display: 'block', paddingBottom: '3px' }}>Company</Typography>
                                            <Controller
                                                name="company"
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        variant="outlined"
                                                        fullWidth
                                                        sx={MuiTextFieldWithFocus}
                                                        error={!!errors.company}
                                                        helperText={errors.company ? errors.company.message : ''}
                                                        {...field}
                                                    />
                                                )}
                                            />
                                        </Stack>
                                    </Grid>

                                    <Grid item xs={12} md={6} display="flex" alignItems="center" sx={{ mt: '28px' }}>
                                        <Controller
                                            name="isFleetCustomer"
                                            control={control}
                                            defaultValue={false}
                                            render={({ field }) => (
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            {...field}
                                                            checked={isFleetCustomer}
                                                            onChange={(e) => {
                                                                field.onChange(e.target.checked);
                                                                setIsFLeetCustomer(e.target.checked);
                                                            }}
                                                            icon={
                                                                <span
                                                                    style={{
                                                                        width: 20,
                                                                        height: 20,
                                                                        borderRadius: '4px',
                                                                        border: '2px solid #E6E6E6',
                                                                        backgroundColor: '#fff',
                                                                        display: 'inline-block',
                                                                        boxSizing: 'border-box',
                                                                        boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.06)',
                                                                    }}
                                                                />
                                                            }
                                                        />
                                                    }
                                                    label="Fleet"
                                                    sx={{ mr: 0, whiteSpace: 'nowrap', color: 'rgba(0, 0, 0, 0.87)' }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    {/* Row 2: Street Address */}
                                    <Grid item xs={12} md={12}>
                                        <Stack spacing={0}>
                                            <Typography sx={{ ...styles.label, display: 'block', paddingBottom: '3px' }}>Street Address</Typography>
                                            <Controller
                                                name="streetAddress"
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        variant="outlined"
                                                        fullWidth
                                                        sx={MuiTextFieldWithFocus}
                                                        error={!!error.streetAddress}
                                                        helperText={error.streetAddress ? error.streetAddress : ''}
                                                        {...field}
                                                        onChange={(e) => {
                                                            setValue('streetAddress', e.target.value);
                                                            setAddressValue({
                                                                ...addressValues,
                                                                streetAddress: e.target.value,
                                                            });
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Stack>
                                    </Grid>

                                    {/* Row 3: City, Province, Postal Code */}
                                    <Grid item xs={12} md={4}>
                                        <Stack spacing={1}>
                                            <Typography sx={styles.label}>City</Typography>

                                            <Controller
                                                name="city"
                                                control={control}
                                                render={({ field }) => (
                                                    <Autocomplete
                                                        forcePopupIcon
                                                        options={(displayedCityOptions || []).map((city) => ({
                                                            label: city.city,
                                                            value: city._id,
                                                            provinceLabel: city?.province?.province,
                                                        }))}
                                                        value={
                                                            !watchedProvince
                                                                ? null
                                                                : (cityList || [])
                                                                      .map((city) => ({ label: city.city, value: city._id }))
                                                                      .find((opt) => opt.value === field.value) || null
                                                        }
                                                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.label || '')}
                                                        isOptionEqualToValue={(option, value) => option.value === value.value}
                                                        inputValue={cityInputValue}
                                                        onInputChange={(event, newInputValue) => {
                                                            setCityInputValue(newInputValue);
                                                            setCityLoadIndex(1); // Reset load index on search
                                                        }}
                                                        filterOptions={(x) => x} // Disable built-in filtering
                                                        ListboxProps={{
                                                            onScroll: handleCityScroll,
                                                            style: { maxHeight: 300, overflow: 'auto' },
                                                        }}
                                                        onChange={(e, newVal) => {
                                                            // Set city value
                                                            field.onChange(newVal?.value || '');

                                                            // Auto-populate province when city is selected
                                                            if (newVal?.value) {
                                                                // Find the full city object to get province data
                                                                const selectedCity = cityList?.find((city) => city._id === newVal.value);
                                                                if (selectedCity?.province?._id) {
                                                                    setValue('province', selectedCity.province._id);
                                                                    clearErrors('province');
                                                                }
                                                                clearErrors('city');
                                                            }
                                                        }}
                                                        renderOption={(props, option, { index }) => {
                                                            const { key, ...otherProps } = props;
                                                            return (
                                                                <li key={index} {...otherProps}>
                                                                    <span>
                                                                        {option.label}
                                                                        {option?.provinceLabel && ` - ${option.provinceLabel}`}
                                                                    </span>
                                                                </li>
                                                            );
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                sx={MuiTextFieldWithFocus}
                                                                error={!!errors.city}
                                                                helperText={errors.city ? errors.city.message : ''}
                                                            />
                                                        )}
                                                    />
                                                )}
                                            />
                                        </Stack>
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <Typography sx={styles.label}>{selectedCountry?.country === 'United States' ? 'State' : ' Province'}</Typography>

                                        <Controller
                                            name="province"
                                            control={control}
                                            render={({ field }) => (
                                                <Autocomplete
                                                    forcePopupIcon
                                                    options={(provinceList || []).map((prov) => ({
                                                        label: prov.province,
                                                        value: prov._id,
                                                    }))}
                                                    value={
                                                        (provinceList || [])
                                                            .map((prov) => ({ label: prov.province, value: prov._id }))
                                                            .find((opt) => opt.value === field.value) || null
                                                    }
                                                    getOptionLabel={(option) => (typeof option === 'string' ? option : option.label || '')}
                                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                                    onChange={(e, newVal) => {
                                                        // Set province value
                                                        field.onChange(newVal?.value || '');

                                                        // Clear city when province changes (city depends on province)
                                                        setValue('city', '');
                                                        setCityInputValue(''); // Also clear the input value for autocomplete
                                                        clearErrors('city');

                                                        // Clear province error
                                                        if (newVal) {
                                                            clearErrors('province');
                                                        }

                                                        // Fetch new city list for the selected province
                                                        if (newVal?.value) {
                                                            fetchCityList(newVal.value);
                                                        } else {
                                                            fetchCityList();
                                                        }
                                                    }}
                                                    renderOption={(props, option, { index }) => {
                                                        const { key, ...otherProps } = props;
                                                        return (
                                                            <li key={index} {...otherProps}>
                                                                <span>{option.label}</span>
                                                            </li>
                                                        );
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            sx={MuiTextFieldWithFocus}
                                                            error={!!errors.province}
                                                            helperText={errors.province ? errors.province.message : ''}
                                                        />
                                                    )}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <Typography sx={{ ...styles.label, display: 'block', paddingBottom: '3px' }}>
                                            {selectedCountry?.country === 'United States' ? 'Zip Code' : 'Postal Code'}
                                        </Typography>
                                        <Controller
                                            name="postalCode"
                                            control={control}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    fullWidth
                                                    sx={MuiTextFieldWithFocus}
                                                    error={!!errors.postalCode}
                                                    helperText={errors.postalCode ? errors.postalCode.message : ''}
                                                    inputProps={{
                                                        style: { textTransform: selectedCountry?.country === 'United States' ? 'none' : 'uppercase' },
                                                        maxLength: selectedCountry?.country === 'United States' ? 5 : 7,
                                                    }}
                                                    onChange={(e) => {
                                                        const input = e.target;
                                                        const rawValue = input.value;

                                                        const selectionStart = input.selectionStart || 0;
                                                        const prevValue = field.value || '';

                                                        // Country-specific processing
                                                        const isUSA = selectedCountry?.country === 'United States';
                                                        const cleaned = isUSA
                                                            ? rawValue.replace(/\D/g, '') // USA: digits only
                                                            : rawValue.replace(/\s/g, '').toUpperCase(); // Canada: remove spaces, uppercase

                                                        // Detect if user is deleting the space at index 3 (Canada only)
                                                        const isDeletingSpace =
                                                            !isUSA && prevValue.charAt(selectionStart - 1) === ' ' && rawValue.length < prevValue.length;

                                                        // Format based on country
                                                        let formatted = cleaned;
                                                        if (!isUSA && cleaned.length > 3) {
                                                            formatted = cleaned.slice(0, 3) + ' ' + cleaned.slice(3, 6);
                                                        }

                                                        // Update form state
                                                        setValue('postalCode', formatted);

                                                        // Country-specific validation
                                                        const isValidLength = isUSA ? formatted.length === 5 : formatted.length === 7;

                                                        if (!formatted) {
                                                            clearErrors('postalCode');
                                                        } else if (!isValidLength) {
                                                            const errorMessage = isUSA
                                                                ? 'Zip code is required - 5 digits'
                                                                : 'Postal code is required - 6 digits';
                                                            setError('postalCode', { message: errorMessage });
                                                        } else {
                                                            clearErrors('postalCode');
                                                        }

                                                        // Adjust caret position
                                                        setTimeout(() => {
                                                            let newCursorPos = selectionStart;

                                                            // If inserting space automatically (Canada only)
                                                            if (!isUSA && !isDeletingSpace && cleaned.length === 4 && selectionStart === 4) {
                                                                newCursorPos += 1;
                                                            }

                                                            // If user deleted the space, move cursor back
                                                            if (isDeletingSpace) {
                                                                newCursorPos -= 1;
                                                            }

                                                            input.setSelectionRange(newCursorPos, newCursorPos);
                                                        }, 0);
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    {/* Row 4: Discount Program and Tax Exemption # */}
                                    <Grid item xs={12} md={6}>
                                        <Stack spacing={0}>
                                            <Typography sx={{ ...styles.label, display: 'block', paddingBottom: '3px' }}>Discount Program</Typography>
                                            <MuiSelect
                                                fullWidth
                                                sx={MuiSelectWithFocus}
                                                value={discountId}
                                                onChange={(e) => setDiscountId(e.target.value)}
                                                displayEmpty
                                            >
                                                <MenuItem value={'none'}>
                                                    <div>None</div>
                                                </MenuItem>
                                                {discountList.map((item, index) => (
                                                    <MenuItem key={index} value={item._id}>
                                                        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} sx={{ width: '100%' }}>
                                                            <div> {item.programName}</div>
                                                            <Chip
                                                                sx={{
                                                                    borderRadius: '100px',
                                                                    height: '32px',
                                                                    background: 'rgba(0, 0, 0, 0.08)',
                                                                    color: 'rgba(0, 0, 0, 0.87)',
                                                                }}
                                                                label={`${item.discount}%`}
                                                            />
                                                        </Stack>
                                                    </MenuItem>
                                                ))}
                                            </MuiSelect>
                                        </Stack>
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <Stack spacing={0}>
                                            <Typography sx={{ ...styles.label, display: 'block', paddingBottom: '3px' }}>Tax Exemption #</Typography>
                                            <Controller
                                                name="taxExemptionNumber"
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField
                                                        variant="outlined"
                                                        fullWidth
                                                        sx={MuiTextFieldWithFocus}
                                                        error={!!errors.taxExemptionNumber}
                                                        helperText={errors.taxExemptionNumber ? errors.taxExemptionNumber.message : ''}
                                                        {...field}
                                                    />
                                                )}
                                            />
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}

                    <Grid
                        container
                        sx={{ boxShadow: 3 }}
                        justifyContent={'start'}
                        borderTop={'none'}
                        padding={'24px'}
                        borderRadius={'10px'}
                        marginTop={'32px'}
                        bgcolor={'white'}
                    >
                        <Grid item xs={12} sm={12} md={3} xl={3}>
                            <Typography variant="h5" sx={{ fontWeight: 400, fontSize: '24px' }}>
                                Vehicle
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={9} xl={9}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} spacing={2}>
                                    {/* <Stack spacing={2}> */}
                                    <Stack spacing={0}>
                                        {Array.isArray(vehicles) &&
                                            vehicles?.map((vehicle, index) => {
                                                return (
                                                    <Box key={index}>
                                                        <Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={2} sx={{ py: '20px' }}>
                                                            {/* Left side - Vehicle details */}
                                                            <Stack spacing={1} flex={1}>
                                                                {/* Vehicle Name with Car Icon */}
                                                                <Typography
                                                                    variant="body1"
                                                                    sx={{
                                                                        display: 'flex',
                                                                        fontWeight: 'medium',
                                                                        alignItems: 'center',
                                                                        gap: 1,
                                                                    }}
                                                                >
                                                                    <CarSvg width={20} height={20} />
                                                                    <p style={{ margin: '0' }}>
                                                                        {vehicle?.year ? vehicle?.year : ''}
                                                                        {vehicle?.vehicleMakeId?.name ? ' ' + vehicle?.vehicleMakeId?.name : ''}
                                                                        {vehicle?.vehicleModelId?.name ? ' ' + vehicle?.vehicleModelId?.name : ''}
                                                                        {vehicle?.vehicleModelTrimId?.name ? ' ' + vehicle?.vehicleModelTrimId?.name : ''}
                                                                    </p>
                                                                </Typography>

                                                                {/* Trim Description */}
                                                                {vehicle?.vehicleModelTrimId?.description && (
                                                                    <Typography variant="body1" display={'flex'} sx={{ fontWeight: 400 }} gap={1}>
                                                                        <TrimIcon />
                                                                        {vehicle?.vehicleModelTrimId?.description}
                                                                    </Typography>
                                                                )}

                                                                {/* VIN */}
                                                                {vehicle?.vin && (
                                                                    <Typography variant="body1" display={'flex'} sx={{ fontWeight: 400 }} gap={1}>
                                                                        <VINIcon />
                                                                        {vehicle?.vin}
                                                                    </Typography>
                                                                )}

                                                                {/* License Plate */}
                                                                {vehicle?.licenseNumber && (
                                                                    <Typography variant="body1" display={'flex'} sx={{ fontWeight: 400 }} gap={1}>
                                                                        <LicensePlateIcon />
                                                                        <p style={{ display: 'flex', gap: 2, fontWeight: 'normal', margin: '0' }}>
                                                                            <Typography>
                                                                                {vehicle?.provinceObject?.provinceCode &&
                                                                                    vehicle?.provinceObject?.provinceCode + ' '}
                                                                            </Typography>
                                                                            {vehicle?.licenseNumber}
                                                                        </p>
                                                                    </Typography>
                                                                )}

                                                                {/* Fleet Number */}
                                                                {isFleetCustomer && vehicle?.fleetUnitNumber && (
                                                                    <Typography variant="body1" display={'flex'} sx={{ fontWeight: 400 }} gap={1}>
                                                                        <CustomerFleet />
                                                                        <Typography fontWeight={400} m={0}>
                                                                            {vehicle?.fleetUnitNumber}
                                                                        </Typography>
                                                                    </Typography>
                                                                )}
                                                            </Stack>

                                                            {/* Right side - Action buttons */}
                                                            <Stack
                                                                spacing={1}
                                                                direction="row"
                                                                //  sx={{ marginTop: '4px' }}
                                                                sx={{ mt: 1 }}
                                                            >
                                                                <Button
                                                                    variant="contained"
                                                                    onClick={() => {
                                                                        handleOpen();
                                                                        setEditVehicle({
                                                                            edit: true,
                                                                            editIndex: index,
                                                                        });
                                                                    }}
                                                                >
                                                                    EDIT
                                                                </Button>
                                                                <Button
                                                                    color="error"
                                                                    variant="contained"
                                                                    onClick={() => {
                                                                        // setDeleteIndex(index);
                                                                        setDeleteIndex(index);
                                                                        setIsDeleteModal(true);
                                                                    }}
                                                                >
                                                                    DELETE
                                                                </Button>
                                                            </Stack>
                                                        </Box>
                                                        {index !== vehicles.length - 1 && <Divider />}
                                                    </Box>
                                                );
                                            })}
                                        {vehicles.length > 0 && <Divider />}
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} display="flex" justifyContent="flex-end" sx={{ mt: 0.5 }}>
                                    <Button variant="outlined" color="primary" startIcon={<AddIcon />} onClick={handleOpen}>
                                        ADD VEHICLE
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {!recordFoundByPhone?.found && showNotesUI && (
                        <Grid
                            container
                            sx={{ boxShadow: 3 }}
                            justifyContent={'start'}
                            borderTop={'none'}
                            padding={'24px'}
                            borderRadius={'10px'}
                            marginTop={'32px'}
                            bgcolor={'white'}
                        >
                            <Grid item xs={12} sm={12} md={3} xl={3}>
                                <Typography variant="h5" sx={{ fontWeight: 400, fontSize: '24px' }}>
                                    Notes
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={9} xl={9}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" sx={{ fontWeight: 500, fontSize: '20px', mb: 1 }}>
                                            Recent Notes
                                        </Typography>
                                        <TextField
                                            id="outlined-basic"
                                            variant="outlined"
                                            fullWidth
                                            onChange={(e) => setNewNote(e.target.value)}
                                            value={newNote}
                                            sx={MuiTextFieldWithFocus}
                                        />
                                        {noteError && <div style={{ color: 'red', marginTop: '8px' }}>Please enter note</div>}
                                        <Button
                                            variant="outlined"
                                            startIcon={<AddIcon />}
                                            sx={{
                                                borderRadius: '4px',
                                                textTransform: 'none',
                                                fontWeight: 500,
                                                marginTop: '11px',
                                            }}
                                            onClick={handleAddNote}
                                        >
                                            ADD
                                        </Button>
                                    </Grid>

                                    {notes?.map((data, index) => (
                                        <Grid item xs={12} key={index}>
                                            <Box
                                                sx={{
                                                    borderRadius: '8px',
                                                    border: '1px solid rgba(0, 0, 0, 0.10)',
                                                    background: '#FFF',
                                                    boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.06)',
                                                    overflow: 'hidden',
                                                    padding: '12px',
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        backgroundColor: '#F8F8F8',
                                                        padding: '0 16px',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        height: '40px',
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            fontWeight: 600,
                                                            color: 'rgba(0, 0, 0, 0.87)',
                                                            fontSize: '14px',
                                                        }}
                                                    >
                                                        {dayjs(data?.createdAt || data?.date).format('MMMM DD, YYYY') +
                                                            ' at ' +
                                                            dayjs(data?.createdAt || data?.date).format('hh:mm A')}
                                                    </Typography>

                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                        <EditIcon
                                                            style={{ cursor: 'pointer', fontSize: '20px', color: 'rgba(0, 0, 0, 0.54)' }}
                                                            onClick={() => {
                                                                setEditDeleteNoteId(data);
                                                                setEditNoteText(data?.note);
                                                            }}
                                                        />
                                                        <DeleteIcon
                                                            style={{ cursor: 'pointer', fontSize: '20px', color: '#D32F2F' }}
                                                            onClick={() => deleteNote(data)}
                                                        />
                                                    </Stack>
                                                </Box>

                                                <Box sx={{ padding: '16px 24px 8px 24px' }}>
                                                    {editDeleteNoteId && notes.indexOf(editDeleteNoteId) === index ? (
                                                        <Stack spacing={2}>
                                                            <TextField
                                                                fullWidth
                                                                multiline
                                                                variant="standard"
                                                                InputProps={{ disableUnderline: true }}
                                                                value={editNoteText}
                                                                onChange={(e) => setEditNoteText(e.target.value)}
                                                                sx={{ mb: 1 }}
                                                            />
                                                            <Divider style={{ margin: '0' }} />
                                                            <Stack direction="row" spacing={2} justifyContent="flex-end">
                                                                <Button
                                                                    variant="text"
                                                                    sx={{
                                                                        p: '4px 10px!important',
                                                                        color: '#D32F2F',
                                                                        backgroundColor: 'rgba(234, 67, 53, 0.10)',
                                                                        borderRadius: '4px',
                                                                        '&:hover': { backgroundColor: 'rgba(234, 67, 53, 0.10)' },
                                                                        fontWeight: 500,
                                                                        lineHeight: '26px',
                                                                        letterSpacing: '0.46px',
                                                                    }}
                                                                    onClick={() => {
                                                                        setEditDeleteNoteId('');
                                                                        setEditNoteText('');
                                                                    }}
                                                                >
                                                                    CANCEL
                                                                </Button>
                                                                <Button
                                                                    variant="text"
                                                                    sx={{
                                                                        p: '4px 10px!important',
                                                                        color: '#006CDD',
                                                                        backgroundColor: 'rgba(0, 108, 221, 0.10)',
                                                                        '&:hover': { backgroundColor: 'rgba(0, 108, 221, 0.10)' },
                                                                        fontWeight: 500,
                                                                        lineHeight: '26px',
                                                                        letterSpacing: '0.46px',
                                                                    }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleEditNote();
                                                                    }}
                                                                    disabled={editNoteText?.trim() === ''}
                                                                >
                                                                    SAVE
                                                                </Button>
                                                            </Stack>
                                                        </Stack>
                                                    ) : (
                                                        <Typography
                                                            variant="body1"
                                                            sx={{
                                                                fontWeight: 400,
                                                                fontSize: '16px',
                                                                color: 'rgba(0, 0, 0, 0.87)',
                                                                fontFamily: 'Roboto',
                                                                fontStyle: 'normal',
                                                                lineHeight: '150%',
                                                                letterSpacing: '0.15px',
                                                            }}
                                                        >
                                                            {data?.note}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                        </Grid>
                    )}

                    <Grid container justifyContent={'end'} marginTop={'32px'} p={3} boxShadow={3} borderRadius={'10px'} bgcolor={'white'} gap={3}>
                        {!showAdditionalDetailUI && (
                            <Grid item>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<AddIcon />}
                                    size="large"
                                    onClick={(e) => {
                                        setShowAdditionalDetailUI(true);
                                    }}
                                >
                                    Add Additional Details
                                </Button>
                            </Grid>
                        )}
                        {!showNotesUI && (
                            <Grid item>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="large"
                                    startIcon={<AddIcon />}
                                    onClick={(e) => {
                                        setShowNotesUI(true);
                                    }}
                                >
                                    Add Note
                                </Button>
                            </Grid>
                        )}
                        <Grid item>
                            <Button
                                variant="contained"
                                color="secondary"
                                size="large"
                                type="submit"
                                onClick={(e) => {
                                    console.log('Calling the deleteCustomer API', validate());
                                    if (validate()) {
                                        control.handleSubmit(onSubmit, onInvalid);
                                    } else {
                                        console.log('Not validated...');
                                        e.preventDefault();
                                    }
                                }}
                            >
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Box>
            <VehicleModalV4
                open={open}
                onClose={handleClose}
                mode={
                    // An existing vehicle on a matched shop_imported customer has to be edited
                    // through the imported endpoint; everything else stays local until save.
                    editVehicle.edit && recordFoundByPhone?.isShopImported && vehicles[editVehicle.editIndex]?.vehcileId
                        ? 'update_shop_imported_vehicle'
                        : editVehicle.edit
                          ? 'update_from_page'
                          : 'create_from_page'
                }
                isFleetCustomer={isFleetCustomer}
                localVehicles={vehicles}
                setLocalVehicles={setVehicles}
                customerId={recordFoundByPhone?.found ? recordFoundByPhone?.id : null}
                vehicleId={editVehicle.edit ? vehicles[editVehicle.editIndex]?.vehcileId : null}
                onSuccess={(updatedVehicle) => {
                    // Only the API-backed modes reach this; merge the server copy back into local state.
                    if (!updatedVehicle) return;
                    setVehicles((prev) => prev.map((v, i) => (i === editVehicle.editIndex ? { ...v, ...mapApiVehicleToLocal(updatedVehicle) } : v)));
                }}
                vehicleData={
                    editVehicle.edit
                        ? {
                              year: vehicles[editVehicle.editIndex]?.year || '',
                              vehicleMakeId: vehicles[editVehicle.editIndex]?.vehicleMakeId?._id || vehicles[editVehicle.editIndex]?.vehicleMakeId,
                              vehicleModelId: vehicles[editVehicle.editIndex]?.vehicleModelId?._id || vehicles[editVehicle.editIndex]?.vehicleModelId,
                              vehicleModelTrimId:
                                  vehicles[editVehicle.editIndex]?.vehicleModelTrimId?.id ||
                                  vehicles[editVehicle.editIndex]?.vehicleModelTrimId?._id ||
                                  vehicles[editVehicle.editIndex]?.vehicleModelTrimId,
                              vin: vehicles[editVehicle.editIndex]?.vin || '',
                              licenseNumber: vehicles[editVehicle.editIndex]?.licenseNumber || '',
                              provinceId: vehicles[editVehicle.editIndex]?.provinceId || vehicles[editVehicle.editIndex]?.provinceObject?._id,
                              fleetUnitNumber: vehicles[editVehicle.editIndex]?.fleetUnitNumber || '',
                              _id: vehicles[editVehicle.editIndex]?.vehcileId,
                              editIndex: editVehicle.editIndex,
                          }
                        : null
                }
            />

            <CommonDialog
                open={isDeleteModal}
                onClose={() => {
                    setDeleteIndex(null);
                    setIsDeleteModal(false);
                }}
                onSave={handleConfirmDelete}
                dialogTitle="Delete Vehicle"
                dialogSubtitle="Are you sure you want to delete this vehicle?"
            />

            <Dialog fullScreen={false} open={showLoader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
            <SuccessMessageModal message={successMessage} open={openSuccessModal} setOpenSuccessModal={setOpenSuccessModal} />
        </>
    );
};

export default NewCustomers;
